import { AfterViewInit, Component, ElementRef, OnDestroy, OnInit, Renderer2 } from '@angular/core';
import { MatLegacyDialogRef as MatDialogRef } from '@angular/material/legacy-dialog';
import { ModalService } from '@core/services/modal/modal.service';
import { SetupPageService } from '@core/services/setup-page/setup-page.service';
import { ResetAppService } from '@core/services/reset-app/reset-app.service';
import { SELECTORS } from '@root/app.config';

@Component({
	selector: 'app-order-placed-modal',
	templateUrl: './order-placed-modal.component.html',
	styleUrls: ['./order-placed-modal.component.scss', './order-placed-modal.responsive.scss'],
})
export class OrderPlacedModalComponent implements OnInit, AfterViewInit, OnDestroy {
	static readonly ID = crypto.randomUUID();

	constructor(
		private modalService: ModalService,
		private resetAppService: ResetAppService,
		private setupPageService: SetupPageService,
		private matDialogRef: MatDialogRef<OrderPlacedModalComponent>,
		private renderer: Renderer2,
		private element: ElementRef,
	) {}

	ngOnInit(): void {
		this.modalService.liftUpModal(this.matDialogRef);
	}

	ngAfterViewInit() {
		this.setZIndex();
	}

	ngOnDestroy() {
		this.removeZIndex();
	}

	onHomePage(): void {
		this.setupPageService.parseLocalLinkHandler();
	}

	onRestart(): void {
		this.matDialogRef.close();
		this.resetAppService.resetServices({ blindDetection: true, partAvailability: true, paymentSession: true });
		this.resetAppService.resetApp({ navigationExtras: { replaceUrl: true } });
	}

	private setZIndex(): void {
		const overlayContainer = this.getOverlayContainer();
		this.renderer.setStyle(overlayContainer, 'z-index', '99999');
	}

	private removeZIndex(): void {
		const overlayContainer = this.getOverlayContainer();
		this.renderer.removeStyle(overlayContainer, 'z-index');
	}

	private getOverlayContainer(): HTMLElement {
		return this.element.nativeElement.closest(SELECTORS.overlay_container);
	}
}
